import { OptionsState } from 'scribe-web-shared/types/extensionOptionsStateTypes';

export enum ExtensionStatus {
  IDLE,
  STARTING_RECORDING,
  RECORDING,
  PAUSED_RECORDING,
  ENDING_RECORDING,
  VIEWING_SCRIBE,
  CREATING_PIN
}

export enum ExtensionConnectionHealth {
  NOT_INSTALLED = 'not_installed',
  /** The initial state while attempting to connect to the extension */
  INITIALIZING = 'initializing',
  HEALTHY = 'healthy',
  /** Cannot connect to the extension */
  UNREACHABLE = 'unreachable',
  /** Recently recovered from an unhealthy state */
  RECOVERING = 'recovering'
}

export type ExtensionHealthState = ExtensionState & {
  connectionHealth: ExtensionConnectionHealth;
};

export interface ExtensionState {
  /**
   * The current status of the extension, i.e. if it's recording, paused, idle, etc.
   */
  status: ExtensionStatus | null;
  version: string | null;
  installed: boolean;
  options?: OptionsState | null;
}
